import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Row, Col, Button, Spinner, 
  // InputGroup, InputGroupText, Input 
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"; // Added Spinner


const SubscriptionForm = ({ show, selectedRow = {}, labels, formikProps, onTranslateClickHandler, translationLoading, lastTranslatedField, isAddOrEdit }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  const [dropdownOpenCurrency, setDropdownOpenCurrency] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(113);
  const toggleCurrency = () => setDropdownOpenCurrency((prevState) => !prevState);


  const handleCurrencyChange = (countryId) => {
    setFieldValue("CountryID", countryId);
    setSelectedCurrency(countryId);
  };

  // Destructure from formikProps for easier access
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = formikProps;

  const { Country, Tags } = useSelector((state) => ({
    Country: state.Module.country,
    Tags: state.Subscriptions.tags
  }));

  const renderField = (item) => {
    const isDisabled = typeof item.disabled === 'function' ? item.disabled(isAddOrEdit) : !!item.disabled;
    const fieldValue = values[item.name] ?? "";

    switch (item.fieldName) {
      case "text-box":
        return (
          <Input
            type={"text"}
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={(e) => {
            const inputValue = e.target.value;
            
            // If it's RoleName field, allow only letters and spaces
            if (item.name === "ScreenNameAr" ) {
              const cleanedValue = inputValue.replace(/[^A-Za-z\u0600-\u06FF\s]/g, '');
              setFieldValue(item.name, cleanedValue);
            } else {
              handleChange(e);
            }
            }}
            maxLength={item.maxLength} 
            minLength={item.minLength}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            disabled={isDisabled}
            required={item.required}
          />
        );
    
      case "email-box":
        return (
          <Input
            type={"email"}
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case "check-box":
        return (
          <Input
            type={"checkbox"}
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case "number":
        return (
          <Input
            type="tel"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange} 
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case 'number-box':
        return (
            <Input
                type="text"
                style={{ textAlign: isRTL ? 'right' : 'left' }}
                id={item.name}
                name={item.name}
                placeholder={t(item.placeholder || item.labelName)}
                value={fieldValue}
                onChange={(e) => {
                    const inputValue = e.target.value;
                    let filteredValue = inputValue.replace(/[^0-9.]/g, '');

                    const parts = filteredValue.split('.');
                    if (parts.length > 2) {
                        filteredValue = parts[0] + '.' + parts.slice(1).join('');
                    }
                    setFieldValue(item.name, filteredValue);
                }}
                onBlur={handleBlur}
                className="form-control"
                invalid={touched[item.name] && !!errors[item.name]}
                disabled={isDisabled}
                required={item.required}
            />
        );

      case "textarea-box":
        return (
          <Input
            type={"textarea"}
            id={item.name}
            name={item.name}
            rows="2"
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case "text-box-translate":
        return (
          <div className="input-group"> 
            <Input
              type={"text"}
              id={item.name}
              name={item.name}
              placeholder={t(item.placeholder || item.labelName)}
              value={fieldValue}
              onChange={(e) => {
              const inputValue = e.target.value;
              
              // If it's RoleName field, allow only letters and spaces
              if (item.name === "ScreenNameEn" ) {
                const cleanedValue = inputValue.replace(/[^A-Za-z\s]/g, '');
                setFieldValue(item.name, cleanedValue);
              } else {
                handleChange(e);
              }
              }}             
              maxLength={item.maxLength} 
              minLength={item.minLength}
              onBlur={handleBlur}
              className="form-control"
              invalid={touched[item.name] && !!errors[item.name]}
              required={item.required}
            />
            {onTranslateClickHandler && item.translateTo && (
              <Button
                type="button"
                onClick={() => onTranslateClickHandler(item.translateTo, fieldValue, setFieldValue, item.name)} // Pass item.name as sourceFieldName
                disabled={!fieldValue || !fieldValue.trim() || translationLoading} // Disable if any translation is loading
              >
                {translationLoading && lastTranslatedField === item.name ? (
                  <Spinner size="sm" />
                ) : (
                  <i className="ri-translate"></i>
                )}
              </Button>
            )}
          </div>
        );

      case "amount-box":
        return (
          <InputGroup>
            <Input
              type="text"
              id={item.name}
              name={item.name}
              placeholder={t(item.placeholder || item.labelName)}
              value={fieldValue}
              onChange={handleChange} 
              onBlur={handleBlur}
              className="form-control"
              invalid={touched[item.name] && !!errors[item.name]}
              required={item.required}
            />

            {/* Dropdown is now a direct child of InputGroup */}
            <Dropdown isOpen={dropdownOpenCurrency} toggle={toggleCurrency}>
              <DropdownToggle caret>{(Country.find((item) => item.ID == selectedCurrency) || {}).CurrencyCode}</DropdownToggle>
              <DropdownMenu>
                {Country.map((c) => (
                  <DropdownItem key={c.ID} value={c.ID} onClick={() => handleCurrencyChange(c.ID)}>{`${c.CurrencyCode} (${c?.[i18n.language]})`}</DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </InputGroup>
        );

      case "plan-dropdown":
        return (
          <Input
            type="select"
            id={item.name}
            name={item.name}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
          >
            <option value={false}>{t('Yearly')}</option>
            <option value={true}>{t('Monthly')}</option>
          </Input>
        )

      case "select-tag-box":
        return (
          <Input
            type="select"
            id={item.name}
            name={item.name}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          >
            <option value="">
              {t(item.placeholder || `Select ${item.labelName}`)}
            </option>
            {Tags.map((opt) => (
              <option key={opt.ID} value={opt.ID}>
                {i18n.language == 'en' ? opt.NameEn : opt.NameAr}
              </option>
            ))}
          </Input>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (show) {
      const countryId = selectedRow.CountryID || 113;
      const isMonthly = selectedRow.IsMonthly || false;
      setSelectedCurrency(countryId);
      setFieldValue("CountryID", countryId);
      setFieldValue("IsMonthly", isMonthly);
    }

  }, [show])

  return (
    <Row>
      {labels.map((item) => {
        
        return (
          <Col sm={6} key={item.name}>
            <div className="mb-3">
              {item.labelName !== "Mobile" && (
                <label htmlFor={item.name} className="col-form-label">
                  {t(item.labelName)}
                  {item.required && <span className="text-danger"> *</span>}
                </label>
              )} 
              {/* Render the field */}
              {renderField(item)}
              {/* Display error for the main field */}
              {/* {item.labelName !== "Mobile" && touched[item.name] && errors[item.name] &&(
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )}
              {item.fieldName === "icon" && touched[item.name] && errors[item.name] && (
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )} */}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default React.memo(SubscriptionForm);